import React from "react";
import { toast } from "react-hot-toast";
import { useTheme } from "../context/ThemeContext";
import { useNavigate } from "react-router-dom";
import { FiHome, FiSun, FiMoon } from "react-icons/fi";

export default function SettingsPage() {
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    toast.success("Logged out successfully.");
    navigate("/login");
  };

  const handleBackHome = () => {
    navigate("/");
  };

  const goToPrivacyPolicy = () => navigate("/privacy-policy");
  const goToTerms = () => navigate("/terms");
  const goToAbout = () => navigate("/about");

  return (
    <div
      className={`min-h-screen p-6 transition-colors duration-300 relative mx-auto ${
        theme === "dark" ? "bg-gray-900 text-gray-100" : "bg-white text-gray-900"
      }`}
    >
      {/* Back to Home Button */}
      <button
        onClick={handleBackHome}
        aria-label="Back to Home"
        className="absolute top-4 left-4 p-3 rounded-md bg-gray-700 text-white hover:bg-gray-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500 transition z-50"
      >
        <FiHome className="h-6 w-6" />
      </button>

      {/* Dark Mode Toggle */}
      <button
        onClick={toggleTheme}
        aria-label="Toggle Dark Mode"
        className="absolute top-4 right-4 p-3 rounded-md bg-gray-700 text-white hover:bg-gray-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500 transition z-50"
      >
        {theme === "dark" ? <FiSun className="h-6 w-6" /> : <FiMoon className="h-6 w-6" />}
      </button>

      <h1 className="text-3xl font-bold mb-2 text-center">Settings</h1>
      <p className="text-center text-gray-500 dark:text-gray-400 mb-8">
        Manage your preferences and account options
      </p>

      {/* Help & Support Section */}
      <section className="mb-10 max-w-xl mx-auto text-center space-y-4">
        <h2 className="text-xl font-semibold mb-3">Help & Support</h2>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
          Need help? Visit these pages for more information:
        </p>
        <div className="flex justify-center gap-6">
          <button
            onClick={goToPrivacyPolicy}
            className="text-blue-600 dark:text-blue-400 hover:underline font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 rounded"
          >
            Privacy Policy
          </button>
          <button
            onClick={goToTerms}
            className="text-blue-600 dark:text-blue-400 hover:underline font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 rounded"
          >
            Terms
          </button>
          <button
            onClick={goToAbout}
            className="text-blue-600 dark:text-blue-400 hover:underline font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 rounded"
          >
            About
          </button>
        </div>
      </section>

      {/* Logout Button */}
      <section className="flex justify-center">
        <button
          onClick={handleLogout}
          className="border border-red-600 text-red-600 px-5 py-2 rounded-md hover:bg-red-600 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 transition-colors duration-300"
        >
          Logout
        </button>
      </section>
    </div>
  );
}
